import { render } from "./TableSuppliers.vue?vue&type=template&id=279ae080&scoped=true"
import script from "./TableSuppliers.vue?vue&type=script&lang=js"
export * from "./TableSuppliers.vue?vue&type=script&lang=js"

import "./TableSuppliers.vue?vue&type=style&index=0&id=279ae080&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279ae080"]])

export default __exports__